import { render, staticRenderFns } from "./linkProductionStatistics.vue?vue&type=template&id=601716e5&scoped=true"
import script from "./linkProductionStatistics.vue?vue&type=script&lang=js"
export * from "./linkProductionStatistics.vue?vue&type=script&lang=js"
import style0 from "./linkProductionStatistics.vue?vue&type=style&index=0&id=601716e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601716e5",
  null
  
)

export default component.exports